import { createFetch } from '@vueuse/core';
import { useIframeDetection } from '@/composables/useIframeDetection';

// Fonction pour obtenir l'URL de l'API depuis window.env (generee par start.sh au runtime)
function getApiUrl(): string {
    if (typeof window !== 'undefined' && window.env && window.env.VITE_BACK_URL) {
        let apiUrl = window.env.VITE_BACK_URL;
        if (!apiUrl.startsWith('http://') && !apiUrl.startsWith('https://')) {
            apiUrl = `https://${apiUrl}`;
        }
        return apiUrl;
    }

    console.error('❌ [useFetchInstance] VITE_BACK_URL is not configured in window.env. API calls will fail.');
    return '';
}

// Initialiser la détection d'iframe
const { isInIframe, getOriginUrl } = useIframeDetection();

export const useFetchInstance = createFetch({
    baseUrl: getApiUrl(),
    combination: 'chain',
    options: {
        beforeFetch({ options }) {
            const originUrl = getOriginUrl();
            options.headers = {
                ...options.headers,
                originUrl: originUrl
            };
            return { options };
        }
    }
});
